import React, { createRef, PureComponent } from 'react';
import { oneOfType, shape, any, string, number, arrayOf } from 'prop-types';
import styled from 'styled-components';
import isEqual from 'lodash/isEqual';
import { DEFAULT_CENTER, getBounds, calcSize } from './util';
import MapBoxMap from '../../MapBox/InteractiveMap';
import { isEmptyObject } from '../../../core/util/object';
import SolvMarker from '../../MapBox/Marker';

const MapContainer = styled.div`
  width: 300px;
  height: 200px;
`;

export default class InteractiveMap extends PureComponent {
  static propTypes = {
    markers: arrayOf(
      shape({
        lat: oneOfType([number, string]).isRequired,
        lng: oneOfType([number, string]).isRequired,
        Marker: any.isRequired,
      })
    ),
    center: shape({
      lat: oneOfType([number, string]).isRequired,
      lng: oneOfType([number, string]).isRequired,
    }),
    className: string,
    CustomMarkerContainer: any,
  };

  static defaultProps = {
    className: 'map-container',
    center: DEFAULT_CENTER,
  };

  state = { bounds: {}, containerSize: {} };

  componentDidMount() {
    this.updateAndSetBounds();
    addEventListener('resize', this.updateAndSetBounds);
  }

  componentDidUpdate = prevProps => {
    const { markers } = this.props;
    if (!isEqual(prevProps.markers, markers)) this.updateAndSetBounds();
  };

  componentWillUnmount() {
    removeEventListener('resize', this.updateAndSetBounds);
  }

  mapRef = createRef();

  updateAndSetBounds = () => {
    const { markers, center } = this.props;
    const containerSize = calcSize(this.mapRef);
    const bounds = getBounds({ markers, center }, containerSize);
    this.setState({ bounds, containerSize });
  };

  render = () => {
    const { className, markers, CustomMarkerContainer } = this.props;
    const {
      containerSize: { height, width },
      bounds: { center: calcCenter, zoom },
    } = this.state;

    const MarkerContainer = CustomMarkerContainer || SolvMarker;

    return (
      <MapContainer className={className} ref={this.mapRef}>
        {!isEmptyObject(calcCenter) && !isEmptyObject(zoom) && (
          <MapBoxMap
            height={height}
            width={width}
            latLong={{ latitude: calcCenter.lat, longitude: calcCenter.lng }}
            zoom={zoom}
          >
            {markers.map(({ lat, lng, Marker, ...others }, i) => (
              <MarkerContainer key={i} latitude={lat} longitude={lng} pin={Marker} {...others} />
            ))}
          </MapBoxMap>
        )}
      </MapContainer>
    );
  };
}
